/** Persisted dismissal for List View archive profile tips. */
export const ARCHIVE_PROFILE_HINT_STORAGE_KEY = 'mylegacybridge:people-companion-hint-hidden';

export const PROFILE_GROUP_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'people', label: 'People' },
  { id: 'companions', label: 'Friends & chosen family' },
  { id: 'pets', label: 'Pets' },
];

const HINT_BY_FILTER = {
  all: {
    title: 'More than a family tree',
    copy: 'You can also preserve family pets, close friends, carers and chosen family in this archive. They stay in List View and do not affect the genealogical tree.',
  },
  people: {
    title: 'People on the family tree',
    copy: 'People can be linked into the genealogical tree. Pets and chosen family stay safely in the archive list.',
  },
  companions: {
    title: 'Chosen family and close connections',
    copy: 'Add close friends, carers, mentors, godparents or anyone who mattered. They can have stories, voice notes and documents without being placed on the bloodline tree.',
  },
  pets: {
    title: 'Beloved pets belong here too',
    copy: 'Preserve pets with photos, stories, voice notes and remembered details. They stay in the archive list, separate from the genealogical tree.',
  },
};

export function getArchiveProfileHintContent(filterId) {
  return HINT_BY_FILTER[filterId] || HINT_BY_FILTER.all;
}

/** Layout segment control (Tree / Pedigree / Fan / Descendants). */
export function treeLayoutBtnClass(active) {
  return active
    ? 'h-9 rounded-[10px] px-3 text-xs font-medium bg-[#1a3429] text-[hsl(42_30%_96%)] shadow-sm hover:bg-[#234035] hover:text-[hsl(42_30%_96%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)] focus-visible:ring-offset-1'
    : 'h-9 rounded-[10px] px-3 text-xs font-medium bg-transparent text-[hsl(32_10%_34%)] border border-transparent hover:border-[hsl(38_16%_82%)] hover:bg-[hsl(38_18%_92%)] hover:text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_48%_58%_/_0.35)] focus-visible:ring-offset-1';
}

/** Outline tool buttons (Full view, Overview, Refresh, etc.). */
export function treeOutlineToolClass(pressed = false) {
  return pressed
    ? 'h-9 rounded-full border border-[hsl(38_14%_76%)] bg-[hsl(42_24%_94%)] px-3 text-xs font-medium text-[hsl(24_12%_22%)] hover:bg-[hsl(42_22%_92%)] hover:text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)] focus-visible:ring-offset-1'
    : 'h-9 rounded-full border border-[hsl(38_14%_84%)] bg-background px-3 text-xs font-medium text-[hsl(24_12%_22%)] hover:border-[hsl(38_14%_76%)] hover:bg-[hsl(42_26%_98%)] hover:text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)] focus-visible:ring-offset-1';
}

/** List View profile group filter chips. */
export function treeFilterChipClass(active) {
  return active
    ? 'rounded-full border border-[#c9a961]/45 bg-[#1a3429] px-3 py-1.5 text-xs font-medium text-[hsl(42_30%_96%)] shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)] focus-visible:ring-offset-1'
    : 'rounded-full border border-[hsl(38_16%_78%)] bg-[hsl(43_32%_98%)] px-3 py-1.5 text-xs font-medium text-[hsl(32_10%_34%)] hover:border-[hsl(38_16%_72%)] hover:bg-[hsl(38_18%_92%)] hover:text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_48%_58%_/_0.35)] focus-visible:ring-offset-1';
}

/** Sticky tab triggers on the tree page. */
export const TREE_TAB_TRIGGER_CLASS =
  'text-[hsl(32_10%_34%)] hover:bg-[hsl(38_18%_92%)] hover:text-[hsl(24_12%_22%)] data-[state=active]:bg-[hsl(152_32%_20%)] data-[state=active]:text-[hsl(42_30%_96%)] data-[state=active]:shadow-[0_2px_8px_-2px_hsl(152_32%_20%_/_0.4)]';

/** Profile type picker in add-profile dialog. */
export function treeProfileTypePickClass(active) {
  return active
    ? 'rounded-xl border border-[#c9a961]/50 bg-[#fffaf3] px-3 py-2.5 text-left text-sm text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)]'
    : 'rounded-xl border border-border/60 bg-background/50 px-3 py-2.5 text-left text-sm text-[hsl(32_10%_42%)] hover:border-[hsl(38_14%_78%)] hover:bg-[hsl(42_26%_98%)] hover:text-[hsl(24_12%_22%)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(43_28%_72%)]';
}

/** Small outline buttons in hint banners. */
export const TREE_HINT_ACTION_CLASS =
  'rounded-full h-8 text-xs border-[hsl(38_16%_78%)] bg-[hsl(43_32%_98%)] text-[hsl(24_12%_22%)] hover:border-[hsl(38_16%_72%)] hover:bg-[hsl(38_18%_92%)] hover:text-[hsl(24_12%_22%)]';
